import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ImportExport from '@mui/icons-material/ImportExport';
import DocumentsUploadContainer from './DocumentsUploadContainer';
import { getInt } from 'utils/functions';
import { Card } from '@totalsoft/rocket-ui';

const UploadDocuments = props => {
  const params = new URLSearchParams(window.location.search);
  sessionStorage.setItem('access_token', params.get('access_token'));
  const { t } = props;
  const { documentId, siteId } = props.match.params;

  return (
    <Card icon={ImportExport} title={t('OfferEdit.Documents.Upload')}>
      <DocumentsUploadContainer documentId={getInt(documentId)} siteId={getInt(siteId)} />
    </Card>
  );
};

UploadDocuments.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object
};

export default withTranslation()(UploadDocuments);
